import { render } from "./TopPanel.vue?vue&type=template&id=f5da0644&scoped=true"
import script from "./TopPanel.vue?vue&type=script&lang=js"
export * from "./TopPanel.vue?vue&type=script&lang=js"

import "./TopPanel.vue?vue&type=style&index=0&id=f5da0644&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f5da0644"

export default script